module.exports = __webpack_public_path__ + "img/intercom.40b0d569.png";